export const executeConsistentAction = (action: () => void) => {
	const promise = new Promise((resolve) => {
		resolve('action');
	});
	promise.then(() => action());
};
